module.exports = __webpack_public_path__ + "img/defaultNew.de5f0ee4.png";